
import { Task } from "@/script/apps/system/entity/SystemEntity";

import { ElLoading, ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { TaskService } from "@/script/apps/system/service/TaskService";

@Options({})
export default class TaskList extends BaseList {
  private queryEntity: Task = {};

  private dataList: Task[] = [];

  private service = new TaskService();

  public initData(): ServiceContext {
    return ServiceFactory.build(
      "sys_task",
      "/sys/task",
      "/sys/task",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    return this.queryEntity;
  }

  public afterLoadList(data: any): void {
    const currDataList: Task[] = data.list as Task[];
    currDataList.forEach((item) => {});
    this.dataList = currDataList;
  }

  public execute(task: Task) {
    const loading = ElLoading.service({
      lock: true,
      text: "任务执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.service.execute(task).then(
      (result: any) => {
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("任务失败，失败原因：" + error.message);
      }
    );
  }
}
